'use client';
import { jsx } from 'react/jsx-runtime';
import { FloatingLabelContextProvider } from '../../contexts/internal/floating-label/index.js';
import { Combobox } from './combobox.component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

let i = renderWithRef('Combobox', null, (t, n)=>{
    let { className: i, children: l } = t, m = new Set([
        'swan-combobox-with-floating-label',
        'swan-input-with-floating-label'
    ]);
    return i && m.add(i), jsx(FloatingLabelContextProvider, {
        children: jsx(RenderComp, {
            root: Combobox,
            forwardedRef: n,
            props: t,
            classNames: m,
            children: l
        })
    });
});
const ComboboxWithFloatingLabel = deprecatedComponent({
    description: 'Use the generic component InputWithFloatingLabel instead',
    displayName: 'ComboboxWithFloatingLabel',
    root: i
});

export { ComboboxWithFloatingLabel };
